import React, { useEffect, useState } from 'react'
import List from '../../components/List'
import Button from '../../components/UI/Button'
import { IBingoFee } from './types'
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined
} from '@ant-design/icons';
import Input from '../../components/UI/Input';
import DateInput from '../../components/UI/DateInput';
import Divider from 'antd/lib/divider';
import { notificationError } from '../../services/notification';
import { Modal } from 'antd';
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth';
import dayjs from "dayjs";

interface IFeeProps {
  feeList: IBingoFee[]
  addOrDeleteFee: (id?: string, fee?: {valid_at: string, value: number}) => void;
}

function Fees(props: IFeeProps) {
  const {canEdit} = useAuth()
  const [form, setForm] = useState({
    validAt: dayjs(),
    value: ''
  })
  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'fees'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  const createFee = () => {
    if(!form.validAt) return notificationError('Please select a valid date')
    if(!form.value) return notificationError('Please select a value')
    const payload = {
      value: parseFloat(form.value) / 100,
      valid_at: dayjs(form.validAt).format('YYYY-MM-DD HH:mm:ss UTC'),
    }
    props.addOrDeleteFee(undefined, payload)
  }

  const warning = (id: string) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this fee?',
      onOk: () => props.addOrDeleteFee(id),
      cancelText: 'Close',
    });
  };


  const getActionButtons = (id: string) => {
    return (
      <div className="roles__button-actions">
        <Button
          onClick={() => {
            warning(id)
          }}
          disabled={!canEdit}
          type='primary'
          style={{ backgroundColor: '#d41d24' }}
        >
          <DeleteOutlined style={{ fontSize: '16px', color: '#FFF' }} />
        </Button>
      </div>
    )
  }



  return (
    <>
    <div className="config-fee">
      <div className="config-fee__list">
        <h4>
          Linked Bingo Fee
        </h4>
        <List
          style={{maxWidth: '100%'}}
          columns={[
            {
              title: 'Valid at',
              dataIndex: 'valid_at',
              key: 'valid_at',
              width: 150,
              render: (value: string) => value.substring(0, 10),
            },
            {
              title: 'Fee',
              dataIndex: 'value',
              key: 'value',
              width: 150,
              render: (value: number) => `${(value * 100).toFixed(2)}%`,
            },
            {
              title: '',
              dataIndex: 'id',
              key: 'id',
              width: 50,
              render: (value: string) => getActionButtons(value),
            },
          ]}
          rows={props.feeList}
        />
      </div>
      <Divider />
      <h4>
        Add New Fee
      </h4>
      <div className="config-fee__input">
        <DateInput
          label="valid at"
          onChange={(e: any) => setForm({...form, validAt: e})}
          value={form.validAt}
          disabled={!canEdit}
        />
        <div className="input-component">
          <div className="input-component__label">
            value
          </div>
          <div className="input-component__input">
            <input
              style={{width: '80px'}}
              className='ant-input'
              min="0.00"
              step="0.01"
              max="100.00"
              type="number"
              onChange={(e: any) => setForm({...form, value: e.target.value})}
              value={form.value}
              disabled={!canEdit}
            />
            &nbsp;&nbsp;
            <span><b>%</b></span>
          </div>
        </div>
        <Button
          onClick={() => createFee()}
          type='primary'
          disabled={!canEdit}
          style={{ backgroundColor: '#2fa4e7', width: 56, height: 32, marginTop: 20 }}
        >
            <PlusOutlined />
          </Button>
      </div>
    </div>
    </>
  )
}

export default Fees